/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   CCPA Module constants
 */

export const KNOW = 'know'
export const DELETE = 'delete'
export const OPT_OUT = 'optOut'
export const OPT_IN = 'optIn'

export const CATEGORIES = 'categories'
export const SPECIFIC = 'specific'

export const CORRECTION = 'correction'

export const WITHDRAW_CONSENT = 'withdrawConsent'

export const SET_CCPA_REQUEST = '@@nzr/ccpa/SET_CCPA_REQUEST'

export const CCPA_EMAIL = 'privacy@zumper.com'
